let accessToken = null;
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const SAP_ENDPOINT = process.env.REACT_APP_API_SAP;
const API_Examportal = process.env.REACT_APP_API_EXAMPORTAL;

// renew token
export async function renewToken(userId) {
  const oldToken = localStorage.getItem("token");
  const res = await fetch(`${API_ENDPOINT}token?platform=1`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${oldToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_id: userId }),
  });

  if (res.ok) {
    const data = await res.json();
    console.log("datais", data);
    accessToken = data?.token;
    localStorage.setItem("token", accessToken);
  } else {
    console.error("Session expired");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
  }
}

// common handler for session expiration
function handleSessionExpired() {
  // clear session data
  localStorage.setItem("loggedOutDueToSessionExpired", "true");
  const flag = localStorage.getItem("loggedOutDueToSessionExpired");
  localStorage.clear();
  localStorage.setItem("loggedOutDueToSessionExpired", flag);

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
}

// wrapper around fetch to handle token expiration
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  if (!options.headers) options.headers = {};
  if (token) {
    options.headers["Authorization"] = `Bearer ${token}`;
  }

  // Ensure platform=1 param
  const urlObj = new URL(`${API_ENDPOINT}${url}`);
  urlObj.searchParams.set("platform", "1");

  const res = await fetch(urlObj.toString(), options);

  if (res.status === 498) {
    handleSessionExpired();
    return Promise.reject(new Error("Session expired"));
  }

  return res;
}

export async function sapFetch(url, options = {}) {
  const urlObj = new URL(`${SAP_ENDPOINT}${url}`);
  urlObj.searchParams.set("platform", "1");

  const res = await fetch(urlObj.toString(), options);
  if (res.status === 498) {
    handleSessionExpired();
    return Promise.reject(new Error("Session expired"));
  }

  return res;
}

export async function ExamAuthFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  if (!options.headers) options.headers = {};
  if (token) {
    options.headers["Authorization"] = `Bearer ${token}`;
  }

  // Ensure platform=1 param
  const urlObj = new URL(`${API_Examportal}${url}`);
  // urlObj.searchParams.set("platform", "1");

  const res = await fetch(urlObj.toString(), options);

  if (res.status === 498) {
    handleSessionExpired();
    return Promise.reject(new Error("Session expired"));
  }

  return res;
}
